module.exports = __webpack_public_path__ + "img/11.e456ad54.png";